import { useState, useEffect } from 'react';
import { getRequiredScriptLoaders, loadScripts, waitForGlobals } from '../utils/scriptLoader';

interface UseScriptLoaderOptions {
  hasAds: boolean;
  hasSystem73: boolean;
}

/**
 * Hook to load external scripts required by the player (IMA SDK, System73).
 * Returns true when all required scripts are loaded and their globals are available.
 */
export const useScriptLoader = ({ hasAds, hasSystem73 }: UseScriptLoaderOptions): boolean => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const loadRequiredScripts = async () => {
      try {
        const scriptLoaders = getRequiredScriptLoaders(hasAds, hasSystem73);
        await loadScripts(scriptLoaders);

        const globalsToWait: string[] = [];
        if (hasAds) {
          globalsToWait.push('google');
        }
        if (hasSystem73) {
          globalsToWait.push('S73ShakaPlayerWrapper');
        }

        if (globalsToWait.length > 0) {
          await waitForGlobals(globalsToWait);
        }

        setIsLoaded(true);
      } catch (error) {
        console.error('Error loading required scripts:', error);
        // Set as loaded anyway to prevent blocking
        setIsLoaded(true);
      }
    };

    loadRequiredScripts();
  }, [hasAds, hasSystem73]);

  return isLoaded;
};
